<router-outlet></router-outlet>
<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color:white">Cargando...</p>
</ngx-spinner> -->
